export const INVOICES_LIMIT = 10

export const INVOICES_DRAWER_STAGES = {
  INITIAL: 'initial',
  INVOICES_ERROR: 'invoices_error',
}
